import styled from 'styled-components';

export const Container = styled.div`
    display:flex;
    flex-direction:column;
    width:200px;
    align-content:center;
    justify-content:center;
    img{
        display:flex;
    }
`;
export const Background = styled.div`
    width:100%;
    background-color:#2F054D;
    align-content:center;
    justify-content:center;
    display:flex;
    @media(min-width:765px){
        height:295px
    }
    @media(max-width:765px){
        height:272px
    }
`
export const WrapSocialMedia = styled.div`
    width:100px;
    display:flex;
    flex-direction:row;
    justify-content:space-evenly;
    margin: 0px auto;
    margin-top:2rem;
`